import { createModuleLayout } from "@/lib/create-module-layout";
import { MODULES } from "@kubdee/shared/module-ids";
import marketingModule from "@kubdee/module-marketing";

/**
 * Shared layout for the Marketing module — hands the module manifest to the
 * factory so the sidebar, module guard, and breadcrumbs stay consistent with
 * the other modules.
 */
export default createModuleLayout({
  moduleId: MODULES.MARKETING,
  moduleConfig: marketingModule,
});
